import { PropsWithoutRef } from 'react';
import {
  TextBox,
  InputType,
  TextBoxValidateOption,
} from '~/shared/components/parts/Textbox/TextBox';
import { IconButton } from '~/shared/components/ui/Button';
import './base.css';
import { mtechnavi } from '~/shared/libs/clientsdk';

interface FormInputTextBoxProps {
  name: string;
  label?: string;
  description?: string;
  type: InputType;
  value?: mtechnavi.api.form.IFormControlText | null;
  validateOption?: TextBoxValidateOption;
  disabled?: boolean;
  onChange?: (v: mtechnavi.api.form.IFormControlText) => void;
}
export const FormInputTextBox = (
  props: PropsWithoutRef<FormInputTextBoxProps>
) => {
  const value: string | null | undefined = props.value?.displayName;
  const handleChangeValue = (value: string) => {
    if (!props?.onChange) {
      return;
    }
    props?.onChange({
      displayName: value,
    });
  };

  return (
    <div className="FormInput FormInputText">
      <span className={props.label !== '' ? 'caption' : 'caption no-name'}>
        {props.label && (
          <div className={props.validateOption?.required ? 'required ' : ''}>
            <div
              className={`topping-label topping-label-with-help ${
                props.disabled ? 'disabled-topping-label' : ''
              }`}
            >
              {props.label || ''}
              {!!props.description && (
                <IconButton
                  name="help"
                  className="HelpIcon"
                  iconType="help"
                  buttonType="basic"
                  onClick={() => {}}
                  caption={props.description}
                />
              )}
            </div>
          </div>
        )}
      </span>
      <TextBox
        name={props.name}
        type={props.type}
        value={value}
        validateOption={props.validateOption}
        disabled={!!props.disabled}
        onChangeState={handleChangeValue}
      ></TextBox>
    </div>
  );
};
